import gql from 'graphql-tag'

export const GET_IS_ALREADY_LOGGED_IN = gql`
  query {
    isAlreadyLoggedIn
  }
`
